module.exports = __webpack_public_path__ + "static/media/plus-white.9c724c08.svg";